import { UserProfile } from "../..";

export const sortUsersByTag = (a: UserProfile, b: UserProfile): number => {
    if (a.tag < b.tag) { return -1; }
    if (a.tag > b.tag) { return 1; }
    return 0;
}